import { IAuthorisedDeviceWithState } from "../interfaces/IAuthorisedDeviceWithState";
import { IAuthorisedDevice } from "../interfaces/IAuthorisedDevice";
import { AuthorisedDeviceRevokingState } from "../enums/AuthorisedDeviceRevokingState";

export const authorisedDevicesMapper = (response: Array<IAuthorisedDevice>): Array<IAuthorisedDeviceWithState> => {
    return response.map((device: IAuthorisedDevice) => ({
        clientName: device.clientName,
        deviceName: device.deviceName,
        tokenId: device.tokenId,
        state: {
            descriptor: AuthorisedDeviceRevokingState.Default
        }
    }));
};
